var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.5 444.7",
    style: {
      enableBackground: "new 0 0 486.5 444.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #ff9800;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.6,401.1c15.7-27.1,15.8-59.4,0.2-86.4L318.2,43.5C302.7,16.2,274.7,0,243.3,0s-59.4,16.3-74.9,43.4 L11.6,314.9c-15.6,27.3-15.5,59.8,0.3,86.9c15.6,26.8,43.5,42.9,74.7,42.9h312.8C430.7,444.7,458.8,428.4,474.6,401.1z  M440.6,381.5c-8.7,15-24.1,23.9-41.3,23.9H86.5c-17,0-32.3-8.7-40.8-23.4c-8.6-14.9-8.7-32.7-0.1-47.7L202.4,62.9 c8.5-14.9,23.7-23.7,40.9-23.7c17.1,0,32.4,8.9,40.9,23.8l156.7,271.4C449.3,349,449.2,366.6,440.6,381.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.3,
    y: 36.6,
    className: "st0",
    width: 128.8,
    height: 128.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 99.1,
    className: "st0",
    width: 199.6,
    height: 199.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 159.4,
    className: "st0",
    width: 266.6,
    height: 252.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 283.1,
    className: "st0",
    width: 413.3,
    height: 130.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 222.3,
    className: "st0",
    width: 341.2,
    height: 130.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.2,312.5c-13.6,0-25,11.4-25,25s11.4,25,25,25c13.1,0,25-11.4,24.4-24.4 C268.2,323.8,256.9,312.5,243.2,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M237,137c-11.9,3.4-19.3,14.2-19.3,27.3c0.6,7.9,1.1,15.9,1.7,23.8c1.7,30.1,3.4,59.6,5.1,89.7 c0.6,10.2,8.5,17.6,18.7,17.6s18.2-7.9,18.7-18.2c0-6.2,0-11.9,0.6-18.2c1.1-19.3,2.3-38.6,3.4-57.9c0.6-12.5,1.7-25,2.3-37.5 c0-4.5-0.6-8.5-2.3-12.5C260.8,139.9,248.9,134.2,237,137z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidWarningIcon);
export default __webpack_public_path__ + "static/media/bid_warning_icon.4a47993a3c75fe9469c8c06138af9fb4.svg";
export { ForwardRef as ReactComponent };